module.exports = __webpack_public_path__ + "img/icon-pencil.157d6a16.svg";